import React, {memo} from "react";
import classNames from "classnames";
import styles from "./styles.module.scss";

interface TextProps {
  text?: string;
  className?: string;
  center?: boolean;
  adaptive?: boolean;
  onClick?: () => void;
  isGray?: boolean
}

const TextBase = memo(({text = "", className, variant, onClick, center, adaptive = false, isGray = false}: TextProps & {
  variant: string
}) => (
  <p
    className={classNames(className, styles[variant], styles.text, {[styles.center]: center}, {[styles.adaptive]: adaptive}, {[styles.gray]: isGray})}
    onClick={onClick}>{text}</p>
));
TextBase.displayName = "TextBase";

export const FirstText = (props: TextProps) => <TextBase {...props} variant="firstText"/>;
export const SecondaryText = (props: TextProps) => <TextBase {...props} variant="secondaryText"/>;
export const ThirtyText = (props: TextProps) => <TextBase {...props} variant="thirtyText"/>;
export const TextBold20 = (props: TextProps) => <TextBase {...props} variant="textBold20"/>;
export const TextBold16 = (props: TextProps) => <TextBase {...props} variant="textBold16"/>;
export const TextBold14 = (props: TextProps) => <TextBase {...props} variant="textBold14"/>;
export const TextBold12 = (props: TextProps) => <TextBase {...props} variant="textBold12"/>;
export const TextMedium20 = (props: TextProps) => <TextBase {...props} variant="textMedium20"/>;
export const TextMedium16 = (props: TextProps) => <TextBase {...props} variant="textMedium16"/>;
export const TextMedium14 = (props: TextProps) => <TextBase {...props} variant="textMedium14"/>;
export const TextMedium12 = (props: TextProps) => <TextBase {...props} variant="textMedium12"/>;
export const ButtonText = (props: TextProps) => <TextBase {...props} variant="buttonText"/>;
